"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconSlider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var Slider_1 = require("@mui/material/Slider");
var FalconSlider = /** @class */ (function (_super) {
    __extends(FalconSlider, _super);
    function FalconSlider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderMinMax = function () {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "d-flex justify-content-between", children: [(0, jsx_runtime_1.jsxs)("div", { className: "text-left font-weight-extra-light", children: ["min.", (0, jsx_runtime_1.jsx)("div", { children: _this.formatValueText(_this.props.minValue) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "text-right font-weight-extra-light", children: ["max.", (0, jsx_runtime_1.jsx)("div", { children: _this.formatValueText(_this.props.maxValue) })] })] }));
        };
        _this.setValue = function (event, value) {
            if (value) {
                _this.props.returnValue(value);
                _this.hideDragElement();
            }
        };
        _this.formatValueText = function (value) {
            return "\u00A3".concat(value ? value.toLocaleString() : _this.props.defaultValue.toLocaleString());
        };
        _this.showDragElement = function () {
            var element = document.getElementsByClassName("MuiSlider-thumb")[0];
            var dragElement = document.createElement("span");
            dragElement.className = "thumb-drag";
            element.firstChild.insertBefore(dragElement, element.nextSibling);
        };
        _this.hideDragElement = function () {
            var dragElement = document.getElementsByClassName("thumb-drag")[0];
            dragElement && dragElement.remove();
        };
        return _this;
    }
    FalconSlider.prototype.componentDidMount = function () {
        !this.props.hideDrag && this.showDragElement();
    };
    FalconSlider.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "falcon-slider ".concat(this.props.className), children: [(0, jsx_runtime_1.jsx)(Slider_1.default, { "aria-labelledby": "discrete-slider", valueLabelDisplay: "on", onChangeCommitted: this.setValue, valueLabelFormat: this.formatValueText, defaultValue: this.props.defaultValue, step: this.props.step, min: this.props.minValue, max: this.props.maxValue, marks: true }), this.renderMinMax()] }));
    };
    return FalconSlider;
}(React.Component));
exports.FalconSlider = FalconSlider;
//# sourceMappingURL=FalconSlider.js.map